import countries from '@omni/kit/components/KitInternationalPhoneNumberInput/constants/countries.json';

export default (phoneNumber: string, regionCode: string): string => {
  if (!phoneNumber || !regionCode) {
    return phoneNumber || '';
  }

  const country = countries.find((c) => c.regionCode === regionCode);

  if (!country || !country?.format) {
    return phoneNumber;
  }

  const digits = phoneNumber.replace(/\D/g, '');
  const formatChars = country.format.split('');
  let digitIndex = 0;
  const formatted = formatChars
    .map((char) => (char === 'X' ? digits[digitIndex++] || '' : char))
    .join('')
    .concat(digits.slice(digitIndex));

  return formatted;
};
